import { Text, Button, Modal } from '@querodelivery/uni-react';
import styles from './export-fare-confirm-modal.module.scss';

interface ExportFareConfirmModalProps {
  open: boolean;
  onClose(): void;
  onCancel(): void;
  onConfirm(): void;
  selectedPlaceNames: string[];
  loading?: boolean;
}

function ExportFareConfirmModal({
  open,
  onClose,
  onCancel,
  onConfirm,
  selectedPlaceNames,
  loading = false,
}: ExportFareConfirmModalProps) {
  if (!open || !selectedPlaceNames.length) {
    return null;
  }

  return (
    <Modal
      header="Exportar tarifa"
      isOpen={open}
      onClose={onClose}
      width="31.25rem"
    >
      <div className={styles.content}>
        <Text>Confirme os estabelecimentos selecionados para exportação:</Text>

        <div className={styles.selectionCard}>
          {selectedPlaceNames.map(placeName => (
            <div key={placeName} className={styles.selectionItem}>
              {placeName}
            </div>
          ))}
        </div>

        <div className={styles.actions}>
          <Button
            variant="outline"
            size="lg"
            onClick={onCancel}
            disabled={loading}
          >
            cancelar
          </Button>

          <Button onClick={onConfirm} loading={loading} disabled={loading}>
            exportar
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ExportFareConfirmModal;
